module.exports = __webpack_public_path__ + "static/img/privacy_count_0.a0cd38ee.svg";